<template>	
	<div class="col-12 inMiddle-area table-responsive">
		<table class="table customize">
			<thead>
				<tr>
					<th>{{$t('accountId')}}</th>
					<th>{{$t('currency')}}</th>
					<th>{{$t('platform')}}</th>
					<th>{{$t('demoLive')}}</th>
					<th>{{$t('accountType')}}</th>
					<th>{{$t('leverage')}}</th>
					<th></th> 
				</tr>
			</thead>
			<tbody  v-if="(!pageLoader1 && demoAccountList != '' && demoAccountList.totalRecords > 0)">
				<tr class="selectHere" v-for="(list,index) in demoAccountList.records">
					<td>{{list.account_id}}</td>
					<td><img :src="'../../../../static/fxView/images/'+currency[list.currency.toUpperCase()]" class="data_currency"></td>
					<td>{{list.platform}}</td>
					<td class="text-capitalize" v-html="(parseInt(list.demo_live) == 0)? 'demo' :'live'"></td>
					<td>{{list.account_type}}</td>
					<td>{{list.leverage}}</td>
					<td width="120">
						<div class="d-flex align-items-center"> 
							<!-- <span class="viewBlance">View Balance</span> -->
							<a href="#" class="prism_btn titleBG btn_xs fundNow" @click="detailDiv(index,'div',list.account_id,list.act_account_id); $parent.$parent.demoAcountDeposit = true ; $parent.$parent.platform_field = false ; $parent.$parent.showTradingAccountModal = false" >{{$t('addFund')}}</a>
							<div class="costompopup pop_xs fundNow1" :ref="'div'+index" v-if="$parent.$parent.demoAcountDeposit && account_id == list.account_id">
								
								<div class="middleBox platfromBox">
									<div class="loader" v-if="depositAddLoader"></div> 
									<div class="modal-header border-bottom"> 
										<h4 class="modal-title" v-if="fund_msz != ''">{{$t('addFundTo')}} <strong>{{list.account_id}}</strong> {{$t('tradingId')}}</h4>
										<h4 class="modal-title" v-else>{{$t('addingFundTo')}} <strong>{{list.account_id}}</strong> {{$t('tradingAcc')}}</h4>
										<button type="button" class="close" @click="$parent.$parent.demoAcountDeposit = false ; fund_msz = ''">&times;</button>
									</div>

									
									<div class="modal-body p-4" >  
										<div class="text-center mb-3" v-if="fund_msz != ''">
											<div class="thumb mb-2">
												<img src="../../../../static/fxView/images/check.svg" alt="success" width="50" height="50" v-if="fund_msz_type == 'success'">
												<img src="../../../../static/fxView/images/cross.svg" alt="success" width="50" height="50" v-if="fund_msz_type == 'error'">
											</div>
											<h4 class="text-capitalize" :class="(fund_msz_type == 'success')? 'green' : 'red'">{{$t(fund_msz)}}</h4>
										</div>
										<div v-else>
											<input type="text" :placeholder="$t('enterAmount')" v-model="amount" v-validate="{ required: true, numeric : true }" name="Amount" class=" form-control"  :class="{ 'is-invalid': submitted && errors.has('Amount') }" ref="amountInput"  >
											<p class="error" v-for="error in errors.collect('Amount')">{{error}}</p>
											<div class="text-center pt-3 mt-3" >
												<a href="#" class="prism_btn btn_xs" @click="submit()">{{$t('addFund')}}</a>
											</div>
										</div>

									</div>
								</div>
							</div>
							<div class="position-relative ml-3">
								<span class="tableoption dotAreaForButton" @click="detailDiv(index,'buttons',list.account_id,list.act_account_id)"><feather type="more-horizontal" size="1rem"></feather></span>								
								<div class="tablefilter box-shadow"  :ref="'buttons'+index" v-if="parseInt(showButtonDetailInfo) == index">
									 <ul>
										<li>
											<router-link :to="{name: 'fxView.changeLeverage' , params: { 'account_id':list.account_id, 'leverage':list.leverage, 'act_account_id' : list.act_account_id , 'demo_live' : list.demo_live, 'platform' : list.platform}}">{{$t('changeLeverage')}}</router-link>
										</li>
										<li>
											<router-link :to="{name: 'fxView.changePassword' , params: { 'account_id':list.account_id, 'act_account_id' : list.act_account_id, 'demo_live' : list.demo_live, 'platform' : list.platform}}">{{$t('changePassword')}}</router-link>
										</li>
										<li>
											<a title="Act Web Trader Demo" href="http://demo.actforex.sysfx.com:8100/trade/actlite.jsp?entry=demo.245" target="_blank" v-if="(list.platform == 'ACT' || list.platform == 'ACT-ZULU')">{{$t('tradeNow')}}</a>
											<router-link :to="'/new-web-trade-link'" target="_blank" v-else-if="(list.platform.toUpperCase() == 'MT4')">{{$t('tradeNow')}}</router-link>
											<router-link :to="{path : '/web-trade-link',query :{'platform' : list.platform}}" target="_blank" v-else>{{$t('tradeNow')}}</router-link>
										</li>
									 </ul>
								</div>
							</div>
						</div>
					</td>
				</tr>
			</tbody>
			<loader-component :pageloader_value="pageLoader1" :type="'table'" :colspan="col_span" :list="demoAccountList" v-else></loader-component>
		</table> 
		<!--<pagination :getList="manageAccountList" :limit="pageLimit" v-if="manageAccountList.totalRecords > 0"></pagination>-->
	</div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
    export default {
        name: 'Demo-Account-List',
        mixins: [fxViewMixins],
        data() {
            return { 
                //===========prop in loader component=======
                col_span : 7,
            	//============message and loader ===========
                
                pageLoader : false,

                depositAddLoader : false,
                fund_msz : '',
                fund_msz_type : '',
                //==========================================
            	
                account_id : '',
				act_account_id : '',
				amount : '',
				submitted : false,
				demoAcountDeposit : false,
				
				showButtonDetailInfo : ''
            }
        },
		props:['pageLoader1'],
        methods:{
        	detailDiv(index,getData,account_id,act_account_id) {
        		this.account_id = account_id
				this.act_account_id = act_account_id
				if(getData == 'div'){
					if ($(this.$refs[getData+index]).hasClass('hide')){
						$(this.$refs[getData+index]).removeClass('hide');
					}else{
						$(this.$refs[getData+index]).addClass('hide');
					} 
				}else{
					if(parseInt(this.showButtonDetailInfo) == index){
						this.showButtonDetailInfo = ''
					}else{
						this.showButtonDetailInfo = index
					}
				}
            },
        	reset(){
        		this.submitted = false
        		this.amount = ''
        	},
        	submit(){
                const _that = this
                this.submitted = true;
                this.$validator.validate().then(valid => {
                    if (valid) {
						if(parseInt(this.amount) > 100000){
							this.fund_msz_type = 'error'
                            this.fund_msz = _that.$t('allowDeposit1lac')
                        }else{
							let input_json={
								'globalParams' :{
									'account_id' : _that.account_id ,
									'act_account_id' : _that.act_account_id,
									'amount' : _that.amount ,
									'comment' : 'deposit'
								},
								'localParams' :{ "parameter" : _that , 'page' : 'man_account'}
							}
							_that._runDemoDeposit(input_json)
						}
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            },
        },
		mounted() { 
            const _that = this
            $(document).on("click", function(event){
                if(!$(event.target).closest('.dotAreaForButton').length){
                    _that.showButtonDetailInfo = ''
                }
            });
        }
    }
</script>

<style scoped>
.error{
	text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/fxView/manageAccounts/demo_account_list.vue